<div class="main-div">
  <div></div>

  <div class="main-header">
    Add/edit a <br />
    participant
  </div>

  <div class="break"></div>

  <div class="main-text">Fill in the participant's <br />details below</div>
  <div class="break"></div>
  <mat-card class="card">
    <mat-card-content>
      <div class="card-header">
        Participant's QR number: <strong>{{ qrcode }}</strong>
      </div>

      <form
        *ngIf="!loading"
        [formGroup]="participantForm"
        (ngSubmit)="onSubmit()"
        class="example-form"
        autocomplete="off"
      >
        <div class="spacer"></div>

        <mat-form-field class="example-full-width">
          <mat-label>Select the event</mat-label>
          <mat-select
            [errorStateMatcher]="matcher"
            (selectionChange)="
              ParticipantformService.change_event_fields($event.value)
            "
            formControlName="participant_event_id"
          >
            <ng-container *ngFor="let item of items | keyvalue">
              <mat-option
                *ngFor="let innerItem of item.value | keyvalue"
                [value]="innerItem.value.event_id"
              >
                {{ innerItem.value.event_name }}
              </mat-option>
            </ng-container>
          </mat-select>
          <mat-hint align="start"
            ><strong>Select the participant's event</strong>
          </mat-hint>
          <mat-error
            *ngIf="
              participantForm.get('participant_event_id').hasError('required')
            "
            >You must select an event</mat-error
          >
        </mat-form-field>

        <app-participantdetails
          [parentData]="data"
          [data]="data"
          [participant]="participantForm.get('participant')"
        ></app-participantdetails>

        <div class="spacer"></div>
        <button
          mat-raised-button
          color="primary"
          type="button"
          class="blue-button"
          (click)="goback()"
        >
          &lt;- Back
        </button>
        <button
          mat-raised-button
          color="primary"
          type="submit"
          class="black-button"
        >
          Save
        </button>
      </form>
    </mat-card-content></mat-card
  >
  <div class="break"></div>
  <div class="spacer"><p></p></div>
</div>
<app-mat-spinner-overlay overlay="true" *ngIf="loading">
</app-mat-spinner-overlay>
